// extracted by mini-css-extract-plugin
export default {"meals":"FoodsAda_meals__ObFkm","meals-appear":"FoodsAda_meals-appear__2Ka-w","loadingDuls":"FoodsAda_loadingDuls__Vn8h5","errorCuy":"FoodsAda_errorCuy__3fKp3"};